import React from "react";
import {Link} from "react-router-dom";
import lockup from "./editor/assets/lockup.png";
import "./editorLink.css";

// A slim bar like the editor's top bar, above the banner. Temporary: it will
// later link to the earthPlace website.
export function EditorBar() {
    return (
        <div className="ep-app-bar">
            <img src={lockup} alt="earthPlace"/>
            <div className="ep-app-divider"/>
            <span className="ep-app-title">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#b98fe6" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M9 3v12M9 15h12M9 15l-6 6" strokeDasharray="0.1 3" strokeWidth="1.7" opacity="0.75"/>
                    <path d="M3 9h12v12H3Z M3 9l6-6h12l-6 6 M21 3v12l-6 6"/>
                </svg>
                Blueprint editor
            </span>
            <Link className="ep-block" to="/projects/earthplace/editor" target="_blank" rel="noopener">Open</Link>
        </div>
    );
}
